import { useState, useEffect } from "react";
import logo from '../../img/logo.png';
import clienteAxios from "../../axios";
import RuletaPremios from './RuletaPremios';
import Cargador from "../../componentes/Cargador";


const Encuesta = () => {

  const queryParameters = new URLSearchParams(window.location.search);
  const folio = queryParameters.get("folio")

  const [preguntas, setPreguntas] = useState([]);
  const [opcionSeleccionada, setOpcionSeleccionada] = useState({});
  const [folioComanda, setFolioComanda] = useState(""); // Estado para el folio de la comanda
  const [correo, setCorreo] = useState(""); // Estado para el correo
  const [error, setError] = useState(""); // Estado para mostrar advertencia
  const [showSuccessModal, setShowSuccessModal] = useState(false); // Modal de éxito
  const [folioUsado, setFolioUsado] = useState(false); // Indica si el folio ya ha sido usado
  const [showQuestions, setShowQuestions] = useState(false); // Estado para mostrar/ocultar preguntas
  const [folioAceptado, setFolioAceptado] = useState(false); // Estado para indicar si el folio fue aceptado
  const [showRuletaModal, setShowRuletaModal] = useState(false); // Estado para mostrar la ruleta  
  const [ListaPremios, setListaPremios] = useState([]);
  const [premioSeleccionado, setPremioSeleccionado] = useState([]);
  const [idRespuesta, setIdRespuesta] = useState(null);
  const [cargador, setCargador] = useState(false);
  const [promosiones, setPromosiones] = useState(0)

  const validateEmail = (correo) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(correo);
  };


  useEffect(() => {
    const iniciarEncuesta = async () => {

    };
    iniciarEncuesta();
  }, []);

  // useEffect(() => {
  //   if (showQuestions) {
  //     obtenerPreguntas();
  //   }
  // }, [showQuestions]);


  const consultarPremios = async () => {
    const config = {
      "Content-Type": "application/json",
    };
    const data = {
      sp: "premios",
      op: "listar",
    };
    try {
      setCargador(true);
      const result = await clienteAxios.post("/api/sp", data, config);
      let premios = [];
      if (result) {
        result.data.data[0].forEach((element) => {
          const { descripcion, color, valor, idPremio, url } = element;
          let dato = {
            option: descripcion,
            style: { backgroundColor: color, textColor: "#FFFFFF" },
            prob: valor,
            url: url,
          };
          premios.push(dato);
        });
        setPremioSeleccionado(result.data.data[1][0])                      
        setListaPremios(premios);        
      }
    } catch (error) {
      console.error("Error al consultar premios:", error);
    } finally {
      setCargador(false);
    }
  };

  const manejarSeleccionOpcion = (idpregunta, valor) => {
    setOpcionSeleccionada((prevState) => ({
      ...prevState,
      [idpregunta]: valor
    }));
  };


  const obtenerPreguntas = async () => {


    try {
      setCargador(true);
      const response = await clienteAxios.post("/api/sp", {
        "sp": "preguntas",
        "op": "listar"
      }, {
        headers: {
          Authorization: `Bearer `
        }
      });

      const preguntasConOpciones = await Promise.all(
        response.data.data[0].map(async (pregunta) => {
          const opcionesResponse = await clienteAxios.post("/api/sp", {
            "sp": "opciones",
            "op": "listar",
            "idpregunta": pregunta.idpregunta
          }, {
            headers: {
              Authorization: `Bearer`
            }
          });

          return {
            ...pregunta,
            opciones: opcionesResponse.data.data[0] || []
          };
        })
      );

      setPreguntas(preguntasConOpciones);
    } catch (error) {
      console.error("Error al obtener preguntas:", error);
    }
    finally {
      setCargador(false);
    }
  };



  // Verificar si el folio ya ha sido usado
  const verificarFolio = async () => {

    if (!validateEmail(correo)) {
      setError("Por favor ingresa un correo válido");
      return;
    }
    setError("");


    setError("");
    try {
      setCargador(true);
      const response = await clienteAxios.post("/api/sp", {
        "sp": "respuestas",
        "op": "folio",
        "folio": folioComanda
      }, {
        headers: {
          Authorization: `Bearer`
        }
      });
      // Verificamos si hay datos en la respuesta
      setCargador(false);
      if (response && response.data && response.data.data.length > 0 && response.data.data[0].length > 0) {
        // Si hay datos en el array, significa que el folio ya fue usado
        setFolioUsado(true);
      } else {

        // Si no hay datos en el array, significa que el folio es nuevo
        setFolioUsado(false);
        await obtenerPreguntas(); // Mostrar las preguntas
        await consultarPremios();
        setShowQuestions(true)
        setFolioAceptado(true); // Indicar que el folio fue aceptado
      }
    } catch (error) {
      console.error("Error verificando el folio:", error);
      setError("Error al verificar el folio. Inténtalo de nuevo.");
    }
    finally {
      setCargador(false);
    }
  };

  const manejarEnvioEncuesta = async () => {



    if (!folioComanda) {
      setError("Por favor, ingresa el folio de tu comanda.");
      return;
    }

    if (!verificarRespuestasCompletas()) {
      setError("Por favor, responde todas las preguntas antes de enviar.");
      return;
    }

    // Construir el objeto con las respuestas seleccionadas
    const respuestasData = preguntas.map((pregunta) => {
      let respuestaSeleccionada = "";

      // Verificar si la pregunta tiene opciones (pregunta de opción múltiple)
      if (pregunta.opciones && pregunta.opciones.length > 0) {
        const idOpcionSeleccionada = opcionSeleccionada[pregunta.idpregunta];

        // Si hay una opción seleccionada, buscar el texto de la opción
        if (idOpcionSeleccionada) {
          const opcionSeleccionadaObj = pregunta.opciones.find(
            (opcion) => opcion.idopcion === idOpcionSeleccionada
          );
          respuestaSeleccionada = opcionSeleccionadaObj ? opcionSeleccionadaObj.texto : "";
        }
      }

      // Si es una pregunta abierta (sin opciones o campo de texto), tomamos el valor directamente
      if (!pregunta.opciones || pregunta.opciones.length === 0 || pregunta.opciones.some(opcion => opcion.esAbierta)) {
        respuestaSeleccionada = opcionSeleccionada[pregunta.idpregunta] || ""; // Guardar la respuesta abierta si existe
      }

      return {
        Pregunta1: pregunta.pregunta, // Texto de la pregunta
        respuesta: respuestaSeleccionada // Texto de la respuesta seleccionada o respuesta abierta
      };
    });



    const dataAEnviar = {
      "sp": "respuestas",
      "op": "guardar",
      "folio": folioComanda, // Folio de la encuesta
      "correo": correo, // Correo del encuestado
      "promosiones":promosiones,
      "data": respuestasData // Las respuestas en formato JSON
    };

    try {


      // Enviar las respuestas al API
      setCargador(true);
      const response = await clienteAxios.post("/api/sp", dataAEnviar, {
        headers: {
          Authorization: `Bearer`
        }
      });

      if (response.status === 200) {
        setIdRespuesta(response.data.data[0][0].Id);

        setShowSuccessModal(true); // Mostrar el modal de éxito si la respuesta fue enviada correctamente
      } else {
        setError("Hubo un error al enviar las respuestas. Intenta de nuevo.");
      }
    } catch (error) {
      console.error("Error al enviar la encuesta:", error);
      setError("Hubo un error al enviar la encuesta. Intenta de nuevo.");
    }
  };






  const verificarRespuestasCompletas = () => {
    const faltantes = preguntas.some(
      (pregunta) => !opcionSeleccionada[pregunta.idpregunta]
    );
    return !faltantes; // Retorna true si todas tienen respuesta
  };

  const cerrarModalExito = () => {
    setShowSuccessModal(false);
    setShowRuletaModal(true); // Mostrar el modal de la ruleta después del éxito
  };


  const cerrarRuleta = () => {
    localStorage.clear()
    setShowRuletaModal(false);
    window.location.href = "https://parquemonchis.com/"; // Redirigir después de usar la ruleta
  };

   const handleChange = (e) => {     
      setPromosiones(e.target.checked);
  };


  return (
    <>
      <div className="min-h-full">
        <div className="bg-black pb-32">
          <header className="py-5">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <img
                src={logo}
                alt="Encuesta Parque Monchis"
                className="w-80 h-23 mx-auto"
              />
            </div>
          </header>
        </div>

        <main className="-mt-32">
          <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6  max-w-full overflow-hidden">
              <h2 className="text-3xl font-bold text-center mb-6 mt-4">Encuesta de satisfacción</h2>
              <p className=" w-full p-4 text-center m-auto font-bold">¡Ayúdanos a mejorar y aprovecha tu cupón!Canjea tu beneficio de martes a viernes con vigencia de 1 mes.</p>
              {cargador && <Cargador />}
              {!folioAceptado ? (
                <div className="w-full md:w-1/3 m-auto p-2 space-y-3">
                  <input
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    type="number"
                    placeholder="Ingresa el folio de tu comanda"
                    value={folioComanda}
                    onChange={(e) => setFolioComanda(e.target.value)}
                    required
                  />
                  <input
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    type="email"
                    placeholder="Ingresa tu cuenta de correo para recibir tu premio"
                    value={correo}
                    onChange={(e) => setCorreo(e.target.value)}
                    required
                  />
                  <div className="w-full">
                    
                    <label className="flex items-center gap-2 cursor-pointer select-none">
                      <input
                        type="checkbox"
                        className="peer hidden"                        
                        checked={promosiones}
                        onChange={handleChange}
                      />
                      <span className="h-5 w-5 flex items-center justify-center rounded border border-gray-400 peer-checked:bg-emerald-600 peer-checked:border-emerald-600 transition">
                        <svg
                          className="hidden peer-checked:block h-3 w-3 text-white"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 13l4 4L19 7" />
                        </svg>
                      </span>
                      <span className="text-gray-700 w-full">
                        ¿Te gustaría recibir  <span className="font-semibold text-emerald-600">promociones exclusivas</span> en tu correo?
                      </span>
                    </label>
                      <div className="w-full p-4">
                        <h1 className="block font-bold">{promosiones?"Si me gustaría!":"No, gracias!"}</h1>
                      </div>
                  </div>

                  <button
                    onClick={verificarFolio}
                    className="bg-blue-500 text-white rounded px-4 py-2 mt-4"
                  >
                    Enviar Folio
                  </button>
                  {error && <p className="text-red-500 text-center mt-4">{error}</p>}
                </div>
              ) : (
                <div className="w-full md:w-1/3 m-auto p-2">
                  <p className="text-center text-xl font-semibold">Folio registrado: {folioComanda}</p>
                </div>
              )}

              {folioUsado && (
                <p className="text-red-500 text-center mt-4">
                  Este número de folio ya ha sido usado.
                </p>
              )}

              {!folioUsado && showQuestions && (
                <>
                  <h2 className="font-bold text-center mb-6 mt-8 text-2xl">Por favor, califica los siguientes aspectos de tu experiencia en Parque Monchis.</h2>
                  <ul>
                    {preguntas.map((pregunta) => (
                      <li key={pregunta.idpregunta} className="border p-4 rounded-lg mb-4 text-center">
                        <div className="text-center">
                          <span className="font-semibold text-3xl">{pregunta.pregunta}</span>
                        </div>
                        <div className="mt-4 text-left justify-start items-start" style={{ marginRight: '-25px', marginLeft: '-10px' }}>
                          {pregunta.opciones && pregunta.opciones.length > 0 ? (
                            pregunta.opciones.map((opcion) => (
                              <div key={opcion.idopcion} className="items-start mr-4">
                                {opcion.esAbierta ? (
                                  <>
                                    <div className="font-semibold mb-2 text-center text-gray-400  p-4 text-2xl">
                                      {opcion.texto}
                                    </div>
                                    <textarea
                                      id={`opcion-${pregunta.idpregunta}`}
                                      name={`pregunta-${pregunta.idpregunta}`}
                                      value={opcionSeleccionada[pregunta.idpregunta] || ""}
                                      onChange={(e) => manejarSeleccionOpcion(pregunta.idpregunta, e.target.value)}
                                      placeholder="Escribe tu respuesta aquí"
                                      className="block w-full   border rounded-lg shadow-sm  p-4 text-2xl"
                                    />

                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="radio"
                                      id={`opcion-${pregunta.idpregunta}-${opcion.idopcion}`}
                                      name={`pregunta-${pregunta.idpregunta}`}
                                      value={opcion.idopcion}
                                      checked={opcionSeleccionada[pregunta.idpregunta] === opcion.idopcion}
                                      onChange={() => manejarSeleccionOpcion(pregunta.idpregunta, opcion.idopcion)}
                                      className="m-2 p-6 "
                                    />
                                    <label htmlFor={`opcion-${pregunta.idpregunta}-${opcion.idopcion}`} className="cursor-pointer  p-4 text-2xl">
                                      {opcion.texto}
                                    </label>
                                  </>
                                )}
                              </div>
                            ))
                          ) : (
                            <p className="ml-4 text-gray-500">No hay opciones disponibles.</p>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>

                  {error && <p className="text-red-500 text-center mt-4">{error}</p>}

                  {/* Botón de enviar encuesta */}
                  <div className="text-center mt-6">
                    <button
                      onClick={manejarEnvioEncuesta}
                      className="bg-blue-500 text-white rounded px-4 py-2"
                    >
                      Enviar Encuesta
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </main>
      </div>

      {/* Modal de éxito */}
      {showSuccessModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/80 bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg text-center">
            <h2 className="text-2xl font-semibold mb-4">¡Encuesta enviada con éxito!</h2>
            <button
              onClick={cerrarModalExito}
              className="bg-green-500 text-white rounded px-4 py-2"
            >
              Ahora da click y vamos por tu premio 🎉
            </button>
          </div>
        </div>
      )}

      {/* Modal de la ruleta */}
      {showRuletaModal && <RuletaPremios onClose={cerrarRuleta} correo={correo} ListaPremios={ListaPremios} idRespuesta={idRespuesta} premioSeleccionado={premioSeleccionado} />}


    </>
  );
};

export default Encuesta;
